module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('homepage', [_c('div', {
    staticClass: "m-block"
  }, [_c('h2', [_vm._v(_vm._s(_vm.pageTitle))]), _vm._v(" "), (this.$i18n.locale === 'pt') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.content.portugueseBody)
    }
  }) : _vm._e(), _vm._v(" "), (this.$i18n.locale === 'en') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(this.content.englishBody)
    }
  }) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6cd64ff2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/portal/CmsTemplate.vue
// module id = 685
// module chunks = 1